import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import CertificateButtonCompleted from './CertificateButtonCompleted';
import CertificateButtonExpired from './CertificateButtonExpired';
import { jsx as _jsx } from "react/jsx-runtime";
const CertificateButton = ({
  expiresAt,
  isCompleted,
  isExpired,
  isSelected,
  name,
  onClick,
  trackId
}) => {
  if (isExpired) {
    return /*#__PURE__*/_jsx(CertificateButtonExpired, {
      expiresAt: expiresAt,
      isSelected: isSelected,
      name: name,
      onClick: onClick
    });
  }
  if (isCompleted) {
    return /*#__PURE__*/_jsx(CertificateButtonCompleted, {
      expiresAt: expiresAt,
      isSelected: isSelected,
      name: name,
      onClick: onClick,
      trackId: trackId
    });
  }
  return /*#__PURE__*/_jsx(SelectableBox, {
    inlineSize: "max-content",
    marginBlockEnd: "800",
    minInlineSize: "248px",
    onClick: onClick,
    padding: "300",
    selected: isSelected,
    type: "default",
    children: name
  });
};
export default CertificateButton;